import React from 'react';
import styles from './badges.module.scss';

interface IBadges extends React.PropsWithChildren {
    header: JSX.Element;
}

const Badges: React.FC<IBadges> = ({ children, header }) => {
    return (
        <div className={styles.badges}>
            {header}
            {children}
        </div>
    );
};

export default Badges;
